import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  Backdrop,
  Box,
  Drawer,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import { Navbar } from 'src/navigation/navbar'
import { UserIcon } from '../user-icon'
import { useAccount, useMe } from 'src/hooks'

import { MenuIcon, TrackgoodIconSmall } from 'src/assets/icons'

import { ROUTES, SPACES } from 'src/constants'
import useStyles from './styles'
import {
  NavBarAccountData,
  NavBarData,
  NavBarConsumerData,
} from 'src/navigation/navbar/navbar-data'
import { createRelativePath, joinAbsRoute } from 'src/common/utils'
import { UserWalletsBallatceList } from '../user-wallets-ballance-list'

interface IMobileHeaderProps {
  headerTitle?: string | ReactNode
  headerDescr?: string
  headerCode?: string
  navigateBack?: boolean
  navigateBackRoute?: string | null
  doNotShowCodeOnMobile?: boolean
}

const MobileHeader = ({
  headerTitle,
  headerCode,
  headerDescr,
  navigateBack,
  navigateBackRoute,
  doNotShowCodeOnMobile,
}: IMobileHeaderProps) => {
  const location = useLocation()
  const theme = useTheme()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const navigate = useNavigate()
  const { accountId } = useParams()

  const { data: account } = useAccount()
  // const { setWhiteLable } = useContext(ThemeSwitchContext)
  const { data: me } = useMe()
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))

  useEffect(() => {
    if (drawerOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [drawerOpen])

  const handleDrawerOpen = () => {
    if (navigateBack) {
      return navigateBackRoute
        ? navigate(navigateBackRoute, { replace: true })
        : navigate(createRelativePath(location))
    }
    setDrawerOpen(true)
  }

  const handleDrawerClose = () => {
    setDrawerOpen(false)
  }

  const handleLogoClick = () => {
    navigate(
      accountId
        ? joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.DASHBOARD)
        : me?.accounts.length === 0
          ? joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD)
          : joinAbsRoute(ROUTES.ACCOUNTS),
    )
  }

  const classes = useStyles({ isTitle: !!headerTitle })

  const mobileHeaderLogo =
    accountId && account?.white_label?.logo
      ? account.white_label.logo
      : me?.white_label
        ? me.white_label.logo
        : false

  return (
    <>
      <Grid
        container
        className={classes.headerWrapper}
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        // maxHeight={'80px'}
      >
        <Grid item>
          <IconButton
            color="inherit"
            onClick={handleDrawerOpen}
            disabled={drawerOpen}
            className={classes.headerIconButton}
          >
            {navigateBack ? <ArrowBackIosIcon /> : <MenuIcon className={classes.headerIcon} />}
          </IconButton>
        </Grid>
        <Grid item>
          <IconButton className={classes.iconWrapper} onClick={handleLogoClick}>
            {mobileHeaderLogo ? (
              <div className={classes.iconHolder}>
                <img src={mobileHeaderLogo} alt="logo" className={classes.iconLogo} />
              </div>
            ) : (
              <TrackgoodIconSmall />
            )}
          </IconButton>
        </Grid>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
          {/* <UserWalletsBallatceList /> */}
          <UserIcon />
        </Box>
      </Grid>
      <Grid className={classes.titleWrapper}>
        {headerTitle && <Typography className={classes.headerTitle}>{headerTitle}</Typography>}
        {headerDescr && <Typography className={classes.headerDescr}>{headerDescr}</Typography>}
        {((doNotShowCodeOnMobile && headerCode && !isMobile) ||
          (doNotShowCodeOnMobile === undefined && headerCode)) && (
          <Typography className={classes.headerCode}>{headerCode}</Typography>
        )}
      </Grid>
      <Backdrop className={classes.headerBackdrop} open={drawerOpen} onClick={handleDrawerClose}>
        <Drawer
          className={classes.headerDrawer}
          variant="persistent"
          anchor="left"
          open={drawerOpen}
        >
          <Grid ml={SPACES.xxxxxl} mt={SPACES.xxxxxl}>
            <IconButton onClick={handleDrawerClose}>
              <ArrowBackIosIcon />
            </IconButton>
          </Grid>
          <Navbar
            navbarData={
              location.pathname.includes(ROUTES.USER)
                ? NavBarConsumerData
                : accountId
                  ? NavBarAccountData
                  : NavBarData
            }
          />
        </Drawer>
      </Backdrop>
    </>
  )
}

export { MobileHeader }
